import { CustomerContact } from 'src/app/api';
import { PopoverRef } from '@mandae/ng-popover';
import * as _ from 'lodash';
import { ProfileContactsService } from '../../../../app/services/profile/profile-contacts.service';
import { PerfilService } from '../../../services/perfil/perfil.service';
import { EditarCriarContatoController } from './editar-criar-contato.controller';
import { ModalSetupContatosController } from './modal-setup-contatos.controller';
import { RemoverContatoController } from './remover-contato.controller';

export class ContatoController {
  public contatos: CustomerContact[];

  private user;

  /*@ngInject*/ constructor(
    private $state,
    private $stateParams,
    private $mdToast,
    private $tour,
    private $uibModal,
    private $profileContacts: ProfileContactsService,
    private Perfil: PerfilService,
  ) { }

  public async $onInit() {
    this.user = this.Perfil.getCacheUserData();
    this.atualizarContatos();

    if (this.$stateParams.tour) {
      this.startTour();
    }

    if (this.$stateParams.abrirModalSetupContatos) {
      const data = await this.$uibModal.open({
        controller: ModalSetupContatosController,
        controllerAs: 'vm',
        templateUrl: 'modalSetupContatos.html',
        windowClass: 'modal-contato sem-tarja-vermelha',
        resolve: {}
      }).result;

      if (data.abrirModalCriacao) {
        this.abrirModalCriacao();
      }
    }
  }

  public abrirModalCriacao() {
    this.abrirModal({
      controller: EditarCriarContatoController,
      templateUrl: 'modalEdicaoContato.html',
      resolve: {
        saveFunction: () => (contactData: CustomerContact) => this.$profileContacts.createContact(contactData),
      }
    });
  }

  public abrirModalEdicao(contato) {
    this.abrirModal({
      controller: EditarCriarContatoController,
      templateUrl: 'modalEdicaoContato.html',
      resolve: {
        saveFunction: () => (contactData: CustomerContact) => this.$profileContacts.updateContact(contactData),
      }
    }, contato);
  }

  public abrirModalRemocao(contato) {
    this.abrirModal({
      controller: RemoverContatoController,
      templateUrl: 'modalRemocaoContato.html',
    }, contato);
  }

  private abrirModal(params, contato: any = {}) {
    this.$uibModal.open(_.merge({
      controllerAs: 'vm',
      windowClass: 'modal-contato sem-tarja-vermelha',
      resolve: {
        contato: () => ({ ...contato }),
        cliente: () => ({ ...this.user }),
      },
    }, params)).result.then(() => {
      this.atualizarContatos();
    });
  }

  private atualizarContatos() {
    this.$profileContacts.getContacts().subscribe(contacts => this.contatos = contacts);
  }

  private startTour() {
    const steps = this.$tour.makeTour([
      {
        title: 'Cadastre seus contatos',
        text: `Inclua ou altere os contatos chave de sua operação.<br/>
              Atendimento: Temas voltados a ocorrências em encomendas;<br/>
              Expedição: processo de cross-docking, coletas e envios;<br/>
              Diretoria: Assuntos relacionados a sua conta (opcional);<br/>
              Financeiro: Assuntos relacionados a faturas, pagamentos e reembolsos;<br/>
              TI: Assuntos relacionados a integrações com a Mandaê (opcional);<br/>`,
        attachTarget: () => document.querySelector<HTMLElement>('app-toolbar .mat-tab-link:nth-child(2)'),
        previous: {
          text: 'Voltar',
          action: (ev, ref) => {
            ref.close('to_previous_section');
            this.$state.go('minha-conta', { tour: true });
          }
        },
        next: {
          text: 'Ir para Endereços',
          action: (ev: MouseEvent, ref: PopoverRef) => {
            ref.close('to_next_section');
            this.$state.go('enderecos', { tour: true });
          },
        },
      },
    ]);

    this.$tour.start(steps).subscribe();
  }
}
